import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../services/axiosInstance";
import * as StorageManager from "../utils/StorageManager";
import constants from "../constants";
import * as paymentSelectors from "../selectors/payment";
import * as paymentActions from "../action/payment";

export const withPaymentConfig = (WrappedComponent) => {
  function WithPaymentConfig(props) {
    const paymentConfigData = useSelector((state) => paymentSelectors.getPaymentConfigData(state));
    const dispatch = useDispatch();
    const [token, setToken] = useState(null);

    useEffect(() => {
      StorageManager.retrieveToken(constants.AUTH_TOKEN).then((value) => {
        setToken(value);
      });
    }, []);

    const { isLoading, data } = useQuery({
      queryKey: ["payment-config-data"],
      queryFn: async () => {
        try {
          return await axiosInstance.get(`/clientarea/payment/config`);
        } catch (e) {}
      },
      retryDelay: 15000,
      enabled: !_.isEmpty(token) && _.isEmpty(paymentConfigData),
    });
    useEffect(() => {
      dispatch(paymentActions.setPaymentConfigData(data));
    }, [data]);
    return <WrappedComponent {...props} loading={isLoading} paymentConfig={paymentConfigData} />;
  }

  return WithPaymentConfig;
};
